import React from 'react'
import styles from './HomeBannerSection.module.css'

const HERO_VIDEO = 'https://pub-a633f3e6ef8e4c978cf9cfad55f4aebf.r2.dev/hero.mp4'   // your R2 custom-domain URL
const HERO_POSTER = 'https://pub-a633f3e6ef8e4c978cf9cfad55f4aebf.r2.dev/hero-poster.jpg'

const HomeBannerSection = () => {
  return (
    <section className={styles.banner} aria-label="Welcome">
      <video
        className={styles.video}
        autoPlay
        loop
        muted
        playsInline
        preload="metadata"
        poster={HERO_POSTER}
      >
        <source src={HERO_VIDEO.replace('.mp4', '.webm')} type="video/webm" />
        <source src={HERO_VIDEO} type="video/mp4" />
      </video>

      {/* Dark overlay so text stays readable over the footage */}
      <div className={styles.overlay} />
    </section>
  )
}

export default HomeBannerSection